/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface Downvote$Params {
  id: string;
}

export function downvote(http: HttpClient, rootUrl: string, params: Downvote$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'data'?: boolean;
}>> {
  const rb = new RequestBuilder(rootUrl, downvote.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'data'?: boolean;
      }>;
    })
  );
}

downvote.PATH = '/api/v1/product-reviews/{id}/downvote';
